module.exports = __webpack_public_path__ + "img/1.936aced2.jpeg";